export default {
  e31734d7c1b1ece7e89c6f860438f113:
    'Order confirmation cashier counter - Floating floor of the cashier counter',
  '5d9d1694e5328a1e252676608ba51256': 'Payment amount',
  '035d0f9a012bbc74df08c66c8c32491b': 'Alipay',
  '91b2ef6547c20214f5c1cfb548a9adab': 'Weixin Pay',
  '6048b9df0c43aeda0116eca3c6fcc969': 'Alipay scan code payment',
  fe66e8c2346b3d606274bec0555c4734: 'Alipay: Learn first, pay later'
};
